import { $api } from "../generated/client";
import type { components } from "../generated/schema";

const PAGE_SIZE = 50;

export type MonitoringEventsFilters = {
  category?: string;
  severity?: components["schemas"]["MonitoringEventDto"]["severity"];
  outcome?: NonNullable<
    components["schemas"]["MonitoringEventDto"]["notificationOutcome"]
  >;
  shopId?: string;
  key?: string;
  q?: string;
};

/** The monitoring journal (`monitoringEvent`), newest first, page after page. */
export function useMonitoringEvents(filters: MonitoringEventsFilters) {
  return $api.useInfiniteQuery(
    "get",
    "/super-admin/monitoring-events",
    {
      params: {
        query: {
          limit: PAGE_SIZE,
          category: filters.category || undefined,
          severity: filters.severity,
          outcome: filters.outcome,
          shopId: filters.shopId || undefined,
          key: filters.key || undefined,
          q: filters.q?.trim() || undefined,
        },
      },
    },
    {
      pageParamName: "before",
      initialPageParam: 0,
      getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
      refetchInterval: 60_000,
    },
  );
}

/** Events of the last hours, per category. */
export function useMonitoringEventsSummary({
  hours = 24,
  shopId,
}: { hours?: number; shopId?: string } = {}) {
  return $api.useQuery(
    "get",
    "/super-admin/monitoring-events/summary",
    { params: { query: { hours, shopId } } },
    { refetchInterval: 60_000 },
  );
}
